import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navigation = () => {
  const [isNavVisible, setNavVisible] = useState(true);

  const handleNavClick = () => {
    setNavVisible(false);
  };

  return (
    <>
      {isNavVisible && (
        <nav className="navigation">
          <ul className="navigation__container">
            <li className="navigation__container-item">
              <Link to="/practice" onClick={handleNavClick}>
                Ćwiczenie
              </Link>
            </li>
            <li className="navigation__container-item">
              <Link to="/exam" onClick={handleNavClick}>
                Próbny Egzamin
              </Link>
            </li>
            <li className="navigation__container-item">
              <Link to="/questions" onClick={handleNavClick}>
                Wszystkie Pytania
              </Link>
            </li>
          </ul>
        </nav>
      )}
      {!isNavVisible && (
        <button className="goBackBtn" onClick={() => setNavVisible(true)}>
          Powrót do Strony Głównej
        </button>
      )}
    </>
  );
};

export default Navigation;
